<div class="card-1" *ngIf="!display_mode || display_mode === 'row'">
  <div class="date"> Выполнить до: <span> 25.06.22 </span></div>
  <div class="content">
    <img [src]="homework.image" alt="">
    <div>
      <div class="subject">{{homework.subject}}</div>
      <div class="title">{{homework.title}}</div>
    </div>
  </div>
</div>

<div class="card-2 content" *ngIf="display_mode === 'col'">
  <div class="title">{{homework.classRoomName}}</div>
  <div class="body">
    <div class="slide">
      <on-ui-cover [cover]="{img: homework.image, form:'base', type:'cover'}"></on-ui-cover>
      <div class="subject">
        <div class="subject-item">{{homework.subject}}</div>
        <div class="subject-title">{{homework.title}}</div>
        <div class="subject-date">Выполнить до: {{homework.date | date:'d.MM.yyyy'}}</div>
        <div class="subject-actions">
            <span class="avatar" *ngFor="let avatar of homework.teachers; trackBy: trackByFn">
              <on-ui-cover [cover]="{img: avatar.image, form:'circle', type:'avatar'}"></on-ui-cover>
            </span>
        </div>
      </div>
      <on-ui-card-menu>
        <div class="menu-item" (click)="onOpenCardInModal()">
          {{ 'user-service-form-3.actions.previews' | customLocale }}
        </div>
        <div class="menu-item" (click)="onEdit()">
          {{ 'user-profile.service-card.edit' | customLocale }}
        </div>
        <div class="menu-item" (click)="onOpenAlert()">
          {{ 'user-profile.service-card.remove' | customLocale }}
        </div>
      </on-ui-card-menu>
    </div>
    <div class="description">{{homework.description}}</div>
    <div class="text">Заданий: {{homework.exercises.length}}</div>
    <div class="actions">
      <div class="exercise">
        <on-ui-cover *ngFor="let item of homework.exercises.slice(0,5); trackBy: trackByFn"
                     [cover]="{img: item.image, form:'base', type:'cover'}"></on-ui-cover>
        <div class="empty-box" *ngIf="homework.exercises.length > 4">
          +{{homework.exercises.length - 5}}
        </div>
      </div>
      <div class="buttons">
        <on-ui-button label="Детали"
                      class="transparent"
                      (onclick)="onClick($event)">
        </on-ui-button>
        <on-ui-button label="Войти в класс"
                      class="transparent"
                      (onclick)="onClick($event)">
        </on-ui-button>
      </div>
    </div>
  </div>
</div>
